export const ACTIONS_DETMIR = {
  ADD_PRODUCTS: 'ADD_DETMIR_PRODUCTS',
  CHANGE_PRODUCT: 'CHANGE_DETMIR_PRODUCT',
};

export const addDetmirProducts = data => ({
  type: ACTIONS_DETMIR.ADD_PRODUCTS,
  data,
});

export const actionChangeDetmirProduct = (product = {}) => ({
  type: ACTIONS_DETMIR.CHANGE_PRODUCT,
  product,
});
